import { combineReducers } from 'redux'

import {
  IState as CategoryPageState,
  reducer as categoryPage
} from './categoryPage'
import { IState as CommonState, reducer as common } from './common'
import experiments, { IExperimentsState } from './experiments'
import {
  IState as FeaturedPageState,
  reducer as featuredPage
} from './featuredPage'
import { IState as HomePageState, reducer as homePage } from './homePage'
import landingPage from './landingPage'
import layout from './layout'
import { IState as IMarketingState, reducer as marketing } from './marketing'
import {
  enhancedRouterReducer,
  IState as LocationState
} from './reactRouterLocation'
import { IState as SearchPageState, reducer as searchPage } from './searchPage'

import {
  IState as TopSellersPageState,
  reducer as topSellersPage
} from './topSellersPage'
import user from './user'

export interface IRootState {
  common: CommonState
  homePage: HomePageState
  featuredPage: FeaturedPageState
  topSellersPage: TopSellersPageState
  categoryPage: CategoryPageState
  landingPage: any
  layout: any
  marketing: IMarketingState
  searchPage: SearchPageState
  user: any
  experiments: IExperimentsState
  router: LocationState
}

export const rootReducer = combineReducers<IRootState>({
  common,
  experiments,
  homePage,
  featuredPage,
  categoryPage,
  topSellersPage,
  landingPage,
  layout,
  marketing,
  searchPage,
  user,
  router: enhancedRouterReducer
})
